export function getProgrammeWeekCount(programme) {
  if (programme?.weeks?.length) {
    return programme.weeks.length;
  }

  if (!programme?.duration) return 1;

  const match = programme.duration.match(/\d+/);
  return match ? Number(match[0]) : 1;
}

export function getProgrammeProgressPercentage(programme, weekIndex) {
  const totalWeeks = getProgrammeWeekCount(programme);
  if (totalWeeks <= 0) return 0;

  return Math.round(((weekIndex + 1) / totalWeeks) * 100);
}

export function getCurrentProgrammeWeek(programme, weekIndex) {
  if (!programme?.weeks?.length) return null;

  const safeIndex = Math.max(
    0,
    Math.min(weekIndex, programme.weeks.length - 1)
  );

  return programme.weeks[safeIndex] || null;
}